import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type { BreedGetBreedersQuery, BreedGetBreedersQueryVariables } from '@gql/graphql';
import { useMemo } from 'react';
import { useBreederOrderBuilder } from '../../BreederListPageController/api/useBreederOrderBuilder';
import { useBreederWhereBuilder } from '../../LitterListPageController/useBreedersCategories/api/useBreederWhereBuilder';

export const BREED_GET_BREEDERS = graphql(`
  query BreedGetBreeders(
    $where: DogBreederWhereInput
    $orderBy: [DogBreederOrderByWithRelationAndSearchRelevanceInput!]
    $take: Int
    $skip: Int
    $breederCardInfoTranslationsWhere: DogBreederTranslationWhereInput
    $breederCardInfoTranslationsWhereBreed: DogBreedTranslationWhereInput
    $breederCardInfoBreedImgsTake: Int
    $breederCardInfoLittersWhere: LitterWhereInput
  ) {
    findManyDogBreeder(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
      ...BreederCardInfo
    }
  }
`);

export const useGetBreeders = (breedNames?: string[]) => {
  const { language } = useRouter();
  const { breederOrderBuilder } = useBreederOrderBuilder();
  const { breederWhereBuilder } = useBreederWhereBuilder();

  const variables = useMemo((): BreedGetBreedersQueryVariables => {
    return {
      take: 16,
      where: breederWhereBuilder({ breedNames }),
      orderBy: breederOrderBuilder(),
      breederCardInfoTranslationsWhere: { language: { equals: language } },
      breederCardInfoTranslationsWhereBreed: { language: { equals: language } },
      breederCardInfoBreedImgsTake: 1,
    };
  }, [breedNames, breederOrderBuilder, breederWhereBuilder, language]);

  const { data, error, loading } = useQuery<BreedGetBreedersQuery, BreedGetBreedersQueryVariables>(
    BREED_GET_BREEDERS,
    {
      variables,
      skip: !breedNames?.length,
      ssr: false,
    },
  );

  return {
    breeders: data?.findManyDogBreeder ?? [],
    breedersError: error,
    breedersLoading: loading,
    breedersVariables: variables,
  };
};
